module.exports = __webpack_public_path__ + "static/media/mod-hotel.5298e915.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/mod-hotel.jpg
// module id = 333
// module chunks = 0